<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="9" xl="10" :order="bPoint.smAndUp?1:3">
        <v-card class="pa-2">
          <ReportResult />
        </v-card>
      </v-col>
      <v-col cols="12" md="3" xl="2" order="2">
        <v-card>
          <v-card-text>
            <ReportFilters/>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import translate from '@/utils/genTable/multilanguageHelper.js'

export default {
  name: 'ReportsBuilder',
  data() {
    return {
      labels: {
        searchOption: translate('Search options :', 'reports.filter')
      }
    }
  },
  components: {
    ReportFilters: () => import('../v2/ReportFilters'),
    ReportResult: () => import('./ReportResult')
  },
  computed: {
    bPoint() {
      return this.$vuetify.breakpoint
    }
  }
}
</script>
<style scoped>
.clearColumnPadding {
  padding: 0px;
}
</style>
